import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, registerAuthExpiredHandler } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = unauth, object = authed
    const [admin, setAdmin] = useState(null);

    const checkPublic = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            setUser(false);
        }
    }, []);

    const checkAdmin = useCallback(async () => {
        try {
            const { data } = await api.get("/admin/auth/me");
            setAdmin(data);
        } catch {
            setAdmin(false);
        }
    }, []);

    useEffect(() => {
        checkPublic();
        checkAdmin();
    }, [checkPublic, checkAdmin]);

    // When any API call returns 401, reset the matching scope state.
    // Protected layouts watch the state and will redirect to the appropriate login.
    useEffect(() => {
        registerAuthExpiredHandler((scope) => {
            if (scope === "admin") setAdmin(false);
            else setUser(false);
        });
    }, []);

    const value = {
        user,
        admin,
        setUser,
        setAdmin,
        refreshUser: checkPublic,
        refreshAdmin: checkAdmin,
        logout: async () => {
            try { await api.post("/auth/logout"); } catch { /* noop */ }
            setUser(false);
        },
        logoutAdmin: async () => {
            try { await api.post("/admin/auth/logout"); } catch { /* noop */ }
            setAdmin(false);
        },
    };
    return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
    const ctx = useContext(AuthCtx);
    if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
    return ctx;
}
